export default "__VITE_ASSET__COwa3yPb__"